import { Bones } from '@simplywallst/ui-core';

import { SkeletonTableRow } from './styled';
import { TableRowCell } from '../../Table';

export const RowSkeleton = () => {
  return (
    <SkeletonTableRow data-cy-id="skeleton-row">
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>

      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell>
        <div>
          <Bones maxWidth="50%" minWidth="50%" />
        </div>
      </TableRowCell>
      <TableRowCell colSpan={2}>
        <div>
          <Bones maxWidth="100%" minWidth="100%" />
        </div>
      </TableRowCell>
      <TableRowCell />
    </SkeletonTableRow>
  );
};
